export default __webpack_public_path__ + "static/leftBackShape-058912bc38cd90e2d14bf7ff61ab469a.png";